import React from 'react';
import styled from 'styled-components';

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const Label = styled.label`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${(p) => p.theme.textSecondary};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Swatch = styled.input`
  width: 44px;
  height: 40px;
  flex: 0 0 auto;
  padding: 3px;
  border: 1px solid ${(p) => p.theme.border};
  border-radius: ${(p) => p.theme.radius};
  background: ${(p) => p.theme.surface};
  cursor: pointer;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  &::-webkit-color-swatch {
    border: none;
    border-radius: 4px;
  }
  &::-moz-color-swatch {
    border: none;
    border-radius: 4px;
  }
`;

const Hex = styled.input`
  flex: 1;
  padding: 0.6rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  color: ${(p) => p.theme.textPrimary};
  background: ${(p) => p.theme.surface};
  border: 1px solid ${(p) => p.theme.border};
  border-radius: ${(p) => p.theme.radius};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${(p) => p.theme.textMuted};
  }
  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.primary};
    box-shadow: 0 0 0 3px ${(p) => p.theme.primary}22;
  }
`;

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export interface ColorInputProps {
  label?: string;
  value: string;
  onChange: (hex: string) => void;
  placeholder?: string;
  containerStyle?: React.CSSProperties;
  id?: string;
}

/**
 * Color field: a native color swatch (picker) paired with a hex text input, so
 * the value can be chosen visually or typed. Emits the hex string (e.g. #FF8A2B).
 */
export const ColorInput: React.FC<ColorInputProps> = ({
  label,
  value,
  onChange,
  placeholder = '#000000',
  containerStyle,
  id,
}) => {
  const swatchValue = HEX_RE.test(value) ? value : '#000000';
  return (
    <Group style={containerStyle}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Row>
        <Swatch
          type="color"
          aria-label={label ? `${label} (seletor de cor)` : 'Seletor de cor'}
          value={swatchValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value.toUpperCase())}
        />
        <Hex
          id={id}
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
      </Row>
    </Group>
  );
};

export default ColorInput;
